module.exports = __webpack_public_path__ + "static/crotrends2020-166098fd9686ffcd974b20e16757a409.png";